import Vue from 'vue';
import Grouping from '@/classes/grouping';
import GroupingQuiz from '@/classes/groupingQuiz';
import InteractiveCaseStudy from '@/classes/interactiveCaseStudy';
import ProgressGrouping from '@/classes/progressGrouping';

const state = {
  groupings: {},
};

const getters = {
  all: state => state.groupings,
  allArray: state => Object.keys(state.groupings).map(id => state.groupings[id]),
  list: state => Object.keys(state.groupings).map(id => state.groupings[id]),
};

const mutations = {
  set(state, groupings) {
    groupings.forEach(g => {
      let grouping;
      if (g.groupingType === 'Case Study') {
        grouping = new InteractiveCaseStudy(g);
      } else if (g.groupingtype === 'Quiz') {
        grouping = new GroupingQuiz(g);
      } else if (g.groupingType === 'Progress') {
        grouping = new ProgressGrouping(g);
      } else {
        grouping = new Grouping(g);
      }
      Vue.set(state.groupings, grouping.id, grouping);
    });
  },
};

const actions = {
  reset({ dispatch, commit, getters, rootGetters }, params) {
    return rootGetters['session/ajax'].post('/groupings/reset', params).then(() => {
      const grouping = getters['all'][params.id];
      commit('flashcardStates/deleteFlashcardStates', { type: 'Asset Association', assetAssociationIds: grouping.assetAssociations.map(aa => aa.id) }, { root: true });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
